import {NgModule, ModuleWithProviders} from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {RequisicaoInterceptorService} from './services/requisicao-interceptor.service';
import {MatIconRegistry} from '@angular/material';

import {SocketService} from './services/socket.service';

import {UtilsService} from './utils/utils.service';
import {UtilsTableService} from './utils/utils-table.service';
import {MaskService} from './utils/mask.service';
import {RoutingConfigService} from './services/config/routing-config.service';
import {GetServicesService} from './services/config/estrutura/get-services.service';
import {DocumentosJsonService} from './services/documentos-json.service';

import {EmpresaConfigService} from './services/config/empresa-config.service';
import {LojaConfigService} from './services/config/loja-config.service';
import {LojasService} from './services/lojas.service';
import {UsuariosService} from './services/usuarios.service';
import {UsuariosConfigService} from './services/config/usuarios-config.service';
import {MetasConfigService} from './services/config/metas-config.service';
import {CategoriasService} from './services/categorias.service';
import {SkusService} from './services/skus.service';

import {ModulosConfigService} from './services/config/modulos-config.service';
import {PaginasConfigService} from './services/config/paginas-config.service';
import {ComponentesConfigService} from './services/config/componentes-config.service';

import {AtendimentoConfigService} from './services/config/atendimento/atendimento-config.service';
import {AtendimentoService} from './services/atendimento.service';

import {AcoesService} from './services/acoes.service';
import {AcaoPerfilService} from './services/acao-perfil.service';
import {DesafiosService} from './services/desafios.service';

import {CausasRaizService} from './services/causas-raiz.service';
import {DimensoesService} from './services/dimensoes.service';
import {SubdimensoesService} from './services/subdimensoes.service';

import {IndicadoresService} from './services/indicadores.service';

import {AgendaService} from './services/agenda.service';
import {AgendaGeralService} from './services/agenda-geral.service';

import {MatrizChaService} from './services/matriz-cha.service';
import {MaturidadeService} from './services/maturidade.service';

import {AutenticacaoService} from './services/autenticacao.service';

import {AuthGuard} from './guards/autenticacao.guard';
import {AdminGuard} from './guards/admin.guard';
import {GestaoGuard} from './guards/gestao.guard';

import {PowerBiService} from './services/power-bi.service';
import {MetaCurvaDiariaFactory} from './models/meta-curva-diaria.model';

@NgModule({
  imports: [HttpClientModule]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RequisicaoInterceptorService,
          multi: true
        },
        MatIconRegistry, SocketService,

        UtilsService, UtilsTableService, MaskService,
        RoutingConfigService, GetServicesService, DocumentosJsonService,

        EmpresaConfigService, LojaConfigService, LojasService,
        UsuariosService, UsuariosConfigService,
        MetasConfigService, CategoriasService, MetaCurvaDiariaFactory,

        AtendimentoConfigService, AtendimentoService, SkusService,

        AcoesService, AcaoPerfilService, DesafiosService,
        CausasRaizService, DimensoesService, SubdimensoesService,
        IndicadoresService,

        AgendaService, AgendaGeralService,

        MatrizChaService, MaturidadeService,

        ModulosConfigService, PaginasConfigService, ComponentesConfigService,
        AutenticacaoService, AuthGuard, AdminGuard, GestaoGuard,
        PowerBiService]
    };
  }
}
